import React, { createContext, useState, useCallback } from "react";

export const AiChatContext = createContext({
  open: false,
  toggle: () => {},
});

const AiChatProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const toggle = useCallback(() => setOpen((prev) => !prev), []);

  return (
    <AiChatContext.Provider value={{ open, setOpen, toggle }}>
      {children}
    </AiChatContext.Provider>
  );
};

export default AiChatProvider;
